import { useNavigate } from 'react-router-dom';
import { RoutesList } from '@abvehicles/routes/Routes';
import { MultipleOptionsTemplate } from '@templates';
import { useAbVehiclesStore } from '@abvehicles/store/store';
import { useState } from 'react';
import { ErrorMessages } from '@types';
import { booleanSchema, parseZodErrors, OPTIONS_REQUIRED_ERROR } from '@utils';
import { ZodError } from 'zod';
import { dangerousPositionQuestions } from '@abvehicles/constants/questionData';

export const DangerousPositionPage = () => {
  const navigate = useNavigate();
  const { updateIsLeftInDangerousPosition, isLeftInDangerousPosition } =
    useAbVehiclesStore();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const questionDataList = dangerousPositionQuestions;

  const radioOptions = [
    {
      id: questionDataList[0].key,
      title: '',
      errorPath: questionDataList[0].key,
      description: questionDataList[0].title,
      onChange: (result: string) => {
        setErrorMessages([]);
        updateIsLeftInDangerousPosition({
          ...isLeftInDangerousPosition,
          [questionDataList[0].key]: result === 'Yes',
        });
      },
      options: [
        {
          id: 'optionYes',
          name: 'optionYes',
          labelText: 'Yes',
          isDefault:
            isLeftInDangerousPosition?.[
              questionDataList[0].key as keyof typeof isLeftInDangerousPosition
            ] === true,
        },
        {
          id: 'optionNo',
          name: 'optionNo',
          labelText: 'No',
          isDefault:
            isLeftInDangerousPosition?.[
              questionDataList[0].key as keyof typeof isLeftInDangerousPosition
            ] === false,
        },
      ],
    },
    {
      id: questionDataList[1].key,
      title: '',
      errorPath: questionDataList[1].key,
      description: questionDataList[1].title,
      onChange: (result: string) => {
        setErrorMessages([]);
        updateIsLeftInDangerousPosition({
          ...isLeftInDangerousPosition,
          [questionDataList[1].key]: result === 'Yes',
        });
      },
      options: [
        {
          id: 'optionYes',
          name: 'optionYes',
          labelText: 'Yes',
          isDefault:
            isLeftInDangerousPosition?.[
              questionDataList[1].key as keyof typeof isLeftInDangerousPosition
            ] === true,
        },
        {
          id: 'optionNo',
          name: 'optionNo',
          labelText: 'No',
          isDefault:
            isLeftInDangerousPosition?.[
              questionDataList[1].key as keyof typeof isLeftInDangerousPosition
            ] === false,
        },
      ],
    },
  ];

  const buttonPrevious = {
    onClick: () => {
      navigate(RoutesList.INVOLVED_IN_ACCIDENT);
    },
  };

  const buttonNext = {
    onClick: () => {
      try {
        const isLeftInDangerousPositionData = booleanSchema(
          questionDataList[0].key,
          OPTIONS_REQUIRED_ERROR.required.message,
        ).parse({
          [questionDataList[0].key]:
            isLeftInDangerousPosition?.[
              questionDataList[0].key as keyof typeof isLeftInDangerousPosition
            ],
        });
        updateIsLeftInDangerousPosition({
          ...isLeftInDangerousPosition,
          [questionDataList[0].key]:
            isLeftInDangerousPositionData?.[
              questionDataList[0]
                .key as keyof typeof isLeftInDangerousPositionData
            ],
        });
        if (
          isLeftInDangerousPositionData[
            questionDataList[0]
              .key as keyof typeof isLeftInDangerousPositionData
          ] === false
        ) {
          navigate(RoutesList.LEAKING);
        }

        if (
          isLeftInDangerousPositionData[
            questionDataList[0]
              .key as keyof typeof isLeftInDangerousPositionData
          ]
        ) {
          const hasContactedPoliceData = booleanSchema(
            questionDataList[1].key,
            OPTIONS_REQUIRED_ERROR.required.message,
          ).parse({
            [questionDataList[1].key]:
              isLeftInDangerousPosition?.[
                questionDataList[1]
                  .key as keyof typeof isLeftInDangerousPosition
              ],
          });
          updateIsLeftInDangerousPosition({
            ...isLeftInDangerousPosition,
            [questionDataList[1].key]:
              hasContactedPoliceData?.[
                questionDataList[1].key as keyof typeof hasContactedPoliceData
              ],
          });
          if (
            hasContactedPoliceData[
              questionDataList[1].key as keyof typeof hasContactedPoliceData
            ]
          ) {
            navigate(RoutesList.WHAT_HAPPENS_NEXT);
          } else {
            navigate(RoutesList.CONTACT_POLICE);
          }
        }
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error) => ({
            message: OPTIONS_REQUIRED_ERROR.required.message,
            path: error.path,
          })),
        );
      }
    },
  };

  return (
    <MultipleOptionsTemplate
      title="Type of issue"
      radioOptions={
        isLeftInDangerousPosition?.[
          questionDataList[0].key as keyof typeof isLeftInDangerousPosition
        ] === true
          ? radioOptions
          : radioOptions.slice(0, 1)
      }
      errorPath={
        isLeftInDangerousPosition?.[
          questionDataList[0].key as keyof typeof isLeftInDangerousPosition
        ] === null
          ? questionDataList[0].key
          : questionDataList[1].key
      }
      errorMessages={errorMessages}
      buttonPrevious={buttonPrevious}
      buttonNext={buttonNext}
    />
  );
};
